// extracted by mini-css-extract-plugin
module.exports = {"select":"ControlledSelect_select__2vZsw","formGroupText":"ControlledSelect_formGroupText__2nEwk"};